import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import { Col, Row } from 'react-bootstrap';

const baseURL = (process.env.REACT_APP_BACK_SERVER || '').replace(/\/?$/, '/');

export default function SummaryView(props) {

    const [show, setShow] = useState(false);
    const [name, setName] = useState("");
    const [winnerScore, setWinnerScore] = useState(false);
    const [winnerAvg, setWinnerAvg] = useState(false);


    let averageTime = 0;
    let myDuration = props.duration.split(":");
    let seconds = parseInt(myDuration[0]) * 60; //convert duration into seconds
    if (props.totalcorrect > 0)
        averageTime = Math.round((seconds / props.totalcorrect) * 100) / 100;

    useEffect(() => {

        const fetchLeaderboard = () => {
            let data = {};
            data["code"] = props.groupcode;
            data["duration"] = parseInt(myDuration[0]);


            axios.post(baseURL + 'api/getLeaderScore', data)
                .then(res => {
                    if (res.data !== "not found") {
                        //setLeaderScore(res.data);
                        if (findHighestScore(res.data) === true || res.data.length < 5) 
                            setWinnerScore(true);
                    } else 
                        setWinnerScore(true);
                      
                    
                }).then(res => {
                    axios.post(baseURL + 'api/getLeaderAvgtime', data)
                        .then(res => {
                            if (res.data !== "not found") {
                                if (findHighestAvg(res.data) === true || res.data.length < 5) 
                                    setWinnerAvg(true);
                            }
                            else 
                                setWinnerAvg(true);
                            
                        }).then(res => {
                            handleShow();
                        })
                })
        };


        fetchLeaderboard();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps




    //check if user's score is one of the top 5
    const findHighestScore = (array) => {
        for (var i = 0; i < array.length; i++) {
            if (props.totalscore > array[i].score)
                return true;
        }
        return false;
    }

    //check if user's avg time is one of the top 5
    const findHighestAvg = (array) => {
        for (var i = 0; i < array.length; i++) {

            if (array[i].avgtime > averageTime) // if new time is less than existing time from DB
                return true;
        }
        return false;
    }

    const handleClose = () => {
        setShow(false);
    }

    const handleShow = () => {
        setShow(true);
    }

    const submitName = () => {

        let data = {};
        data["groupcode"] = props.groupcode;
        data["score"] = props.totalscore;
        data["avgtime"] = averageTime;

        data["duration"] = myDuration[0];
        data["name"] = name;

        if (winnerScore === true)

            data["scoreflag"] = 1;

        if (winnerAvg === true)
            data["avgflag"] = 1;


        axios.post(baseURL + 'api/saveLeaderScore', data)
            .then(res => {
                if (res.data === "success")
                    console.log("data saved")
                else
                    console.log("data not saved")

                handleClose();
            })

    }
    

    return (
        <div>
            <Modal show={show} onHide={handleClose}
                {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="my-modal"
            >

                <Modal.Body className="text-center">
                    <Row className="align-items-end">
                        <Col md={3} ><div className=" summarySideTitle">{window.outerWidth > 1025 && props.type === "major" && <>Major</>}{window.outerWidth > 1025 && props.type === "minor" && <>Minor</>}
                        </div>
                        </Col>
                        <Col md={6}><div className="summaryTitle ">Time's Up</div>
                        </Col>
                        <Col md={3} className="summarySideTitle ">
                        {window.outerWidth <= 1025 && props.type === "major" && <>Major &nbsp;</>}{window.outerWidth <= 1025 && props.type === "minor" && <>Minor &nbsp;</>}
                            {myDuration[0]}min
                        </Col>
                    </Row>
                    <br />
                    <Row className="align-items-center ">
                        <Col className="summarySideTitle text-end ">
                            SCORE:
                        </Col>
                        <Col className="summaryNumber text-start">
                            {props.totalscore}
                        </Col>
                    </Row>
                    <Row className="align-items-center">
                        <Col className=" summarySideTitle text-end">
                            CORRECT:
                        </Col>
                        <Col className="summaryNumber text-start">
                            {props.totalcorrect}
                        </Col>
                    </Row>
                    <Row className="align-items-center">
                        <Col className=" summarySideTitle text-end">
                            AVGTIME:
                        </Col>
                        <Col className="summaryNumber text-start">
                            {averageTime}sec
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {props.totalcorrect > 1 && (winnerScore === true || winnerAvg === true) && <><br />Congratulations! You are on the leaderboard!<br />
                                Please key in your nickname:<br />
                                <input
                                    className="groupCodeField"
                                    placeholder=""
                                    type="text"
                                    value={name}
                                    maxLength="5"
                                    onChange={e => setName(e.target.value)}
                                />
                            </>}

                        </Col>
                    </Row>
                    <Row className="align-items-center">
                        <Col className=" summarySideTitle">
                            {props.totalcorrect > 1 && (winnerScore === true || winnerAvg === true) && <><Button className="yesnoButton" onClick={submitName}>
                                SUBMIT
                            </Button>
                                <Button className="yesnoButton" onClick={handleClose}>
                                    CANCEL
                                </Button></>
                            }
                            {(props.totalcorrect < 2 || (winnerScore !== true && winnerAvg !== true)) &&
                                <Button className="yesnoButton" onClick={handleClose}>
                                    CLOSE
                                </Button>
                            }
                        </Col>
                    </Row>

                </Modal.Body>

            </Modal>
        </div>
    );


}
